import { useMemo } from 'react';
import { useRuler2dDimensions } from '../hooks/useRuler2dDimensions';
import { CORNER_SIZE } from '../../plot/utils/graph.utils';
import { useUpdateByBoundary } from '../hooks/useUpdateByBoundary';

export const corners = [
  'top left',
  'top right',
  'bottom left',
  'bottom right',
] as const;
export type Corner = typeof corners[number];

interface Props {
  corner: Corner;
}

export const Ruler2dResizeCornerHandle: React.FC<Props> = ({ corner }) => {
  const updateByBoundary = useUpdateByBoundary();
  const { x, y, height, width } = useRuler2dDimensions();
  const cursor = useMemo(() => {
    switch (corner) {
      case 'top left':
      case 'bottom right':
        return 'nwse-resize';

      case 'top right':
      case 'bottom left':
        return 'nesw-resize';
    }
  }, [corner]);

  const onMouseDown = (event: React.MouseEvent<SVGRectElement>) => {
    if (corner.includes('top')) {
      updateByBoundary(event, 'yBoundary', 'voltageStart');
    }
    if (corner.includes('bottom')) {
      updateByBoundary(event, 'yBoundary', 'voltageEnd');
    }
    if (corner.includes('left')) {
      updateByBoundary(event, 'xBoundary', 'timestampStart');
    }
    if (corner.includes('right')) {
      updateByBoundary(event, 'xBoundary', 'timestampEnd');
    }
  };

  const xCorner =
    corner === 'top left' || corner === 'bottom left' ? x : x + width;
  const yCorner =
    corner === 'top left' || corner === 'top right' ? y : y + height;

  return (
    <rect
      data-testid={`ruler2d-${corner.replace(' ', '-')}-handle`}
      fill='transparent'
      opacity={0.5}
      x={xCorner - CORNER_SIZE / 2}
      y={yCorner - CORNER_SIZE / 2}
      width={CORNER_SIZE}
      height={CORNER_SIZE}
      cursor={cursor}
      onMouseDown={(event) => {
        onMouseDown(event);
      }}
    />
  );
};
